import SvgColor from "../../../../../minimals/components/svg-color";

// ----------------------------------------------------------------------

const icon = (name: string) => <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const ICONS = {
  blog: icon("ic_blog"),
  cart: icon("ic_cart"),
  chat: icon("ic_chat"),
  mail: icon("ic_mail"),
  user: icon("ic_user"),
  file: icon("ic_file"),
  lock: icon("ic_lock"),
  label: icon("ic_label"),
  blank: icon("ic_blank"),
  kanban: icon("ic_kanban"),
  folder: icon("ic_folder"),
  banking: icon("ic_banking"),
  booking: icon("ic_booking"),
  invoice: icon("ic_invoice"),
  calendar: icon("ic_calendar"),
  disabled: icon("ic_disabled"),
  external: icon("ic_external"),
  menuItem: icon("ic_menu_item"),
  ecommerce: icon("ic_ecommerce"),
  analytics: icon("ic_analytics"),
  dashboard: icon("ic_dashboard"),
  company: icon("ic_company")
};

const documentsNavUsers = new Set([
  "afriedman@madisoncres.com",
  "bfreylicher@madisoncres.com",
  "sdavidowitz@madisoncres.com",
  "tnewman@madisoncres.com",
  "agoldstein@madisoncres.com",
  "jshonek@madisontitle.com",
  "ymeister@madisontitle.com",
  "srubin@madisontitle.com",
  "hcohen@madison1031.com"
]);

const canAccessDocumentsNav = (email?: string) =>
  Boolean(email && documentsNavUsers.has(email.trim().toLowerCase()));

// The 1031 (Madex) department works off the exchange deadline calendar rather than
// the title closing calendar, so their nav item points there instead.
const EXCHANGE_CALENDAR_URL = "https://explore.madison1031.com";

const calendarNavItem = (isExchangeUser?: boolean) =>
  isExchangeUser
    ? { title: "1031 Calendar", path: EXCHANGE_CALENDAR_URL, icon: ICONS.calendar }
    : { title: "Closing Calendar", path: "/calendar", icon: ICONS.calendar };

export const getNavConfig = (email?: string, isExchangeUser?: boolean) => [
  {
    subheader: "Workspace",
    items: [
      {
        title: "Orders",
        path: "/orders",
        icon: ICONS.menuItem
      },
      ...(canAccessDocumentsNav(email)
        ? [{ title: "Documents", path: "/documents", icon: ICONS.file }]
        : []),
      calendarNavItem(isExchangeUser)
    ]
  },
  {
    subheader: "express order placement",
    items: [
      {
        title: "Order Entry",
        path: "/order-entry",
        icon: ICONS.banking
      },
      {
        title: "Searches",
        path: "/searches",
        icon: ICONS.analytics
      },
      {
        title: "Confirmation",
        path: "/confirmation",
        icon: ICONS.mail
      }
    ]
  },
  {
    subheader: "phonebook",
    items: [
      {
        title: "Phonebook",
        path: "/phonebook",
        icon: ICONS.user
      }
    ]
  }
];

const navConfig = getNavConfig();

export default navConfig;
